@let isConcealed = enabled && !revealed;

<div class="sensitiveMediaBlur">
  <div class="content" [class.isBlurred]="isConcealed">
    <ng-content></ng-content>
  </div>

  @if (isConcealed) {
    <div class="overlay" [class.blocksClicks]="blockBackgroundClicks">
      @if (allowReveal) {
        <div class="reveal">
          <mat-icon class="revealIcon">visibility_off</mat-icon>
          <span class="revealLabel">{{
            "sensitiveMedia.label" | translate
          }}</span>
          <button
            type="button"
            ca-action-button
            class="revealButton"
            (click)="reveal($event)"
          >
            {{ "sensitiveMedia.tapToView" | translate }}
          </button>
        </div>
      } @else {
        <mat-icon class="revealIconSmall">visibility_off</mat-icon>
      }
    </div>
  }

  @if (enabled && !isConcealed && allowReveal) {
    <button
      type="button"
      mat-icon-button
      class="concealButton"
      (click)="conceal($event)"
    >
      <mat-icon>visibility_off</mat-icon>
    </button>
  }
</div>
